var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "q-collapse-item",
      class: { "is-active": _vm.isActive, "is-disabled": _vm.disabled },
    },
    [
      _c(
        "div",
        {
          attrs: {
            role: "tab",
            "aria-expanded": _vm.isActive,
            "aria-controls": `q-collapse-content-${_vm.id}`,
            "aria-describedby": `q-collapse-content-${_vm.id}`,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "q-collapse-item__header",
              class: {
                focusing: _vm.focusing,
                "is-active": _vm.isActive,
              },
              attrs: {
                id: `q-collapse-head-${_vm.id}`,
                role: "button",
                tabindex: _vm.disabled ? undefined : 0,
              },
              on: {
                click: _vm.handleHeaderClick,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ]) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.stopPropagation()
                  return _vm.handleEnterClick.apply(null, arguments)
                },
                focus: _vm.handleFocus,
                blur: function ($event) {
                  _vm.focusing = false
                },
              },
            },
            [
              _vm._t("title", function () {
                return [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "q-collapse-item__arrow q-icon-arrow-right",
                class: { "is-active": _vm.isActive },
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("q-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive",
              },
            ],
            staticClass: "q-collapse-item__wrap",
            attrs: {
              id: `q-collapse-content-${_vm.id}`,
              role: "tabpanel",
              "aria-hidden": !_vm.isActive,
              "aria-labelledby": `q-collapse-head-${_vm.id}`,
            },
          },
          [
            _c(
              "div",
              { staticClass: "q-collapse-item__content" },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }